<script setup lang="ts">
const head: any = useLocaleHead({
  addDirAttribute: true,
  addSeoAttributes: true,
})

const htmlAttrs = computed(() => head.value.htmlAttrs!)

const route = useRoute()

const refCode: any = useCookie('refCode')
// const refCode: any = useCookie('refCode', { maxAge: 86400 })

refCode.value = refCode.value || route?.query?.ref

// const url = useRequestURL()
</script>

<template>
  <Html :lang="htmlAttrs.lang" :dir="htmlAttrs.dir">
    <!-- <Head>
      <template v-for="link in head?.link" :key="link.id">
        <Link :id="link.id" :rel="link.rel" :href="`${url.href}${link.href}`" :hreflang="link.hreflang" />
      </template>
      <template v-for="meta in head?.meta" :key="meta.id">
        <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
      </template>
    </Head> -->
    <Body>
      <div class="relative w-full overflow-hidden pb-20">
        <DefaultHeader />

        <div class="relative pt-10 pb-20">
          <slot />
        </div>

        <NewsLetter />

        <DefaultFooter />

        <GroupButtonFloat />

        <CookieSection />
      </div>
    </Body>
  </Html>
</template>
